import type { AuthenticationToken } from '..';
import AuthenticationDao from '../dao/authentication.dao';
import type { Environment } from '../interfaces/environment';

export abstract class AuthenticationService {
  static async authenticateWithUsernameAndPassword(
    env: Environment,
    username: string,
    password: string
  ): Promise<AuthenticationToken> {
    const token = await AuthenticationDao.authenticateWithUsernameAndPassword(
      env,
      username,
      password
    );
    return token;
  }

  static resetUserPassword(env: Environment, username: string): Promise<any> {
    return AuthenticationDao.resetPassword(env, username);
  }

  static recoverUsername(env: Environment, email: string): Promise<any> {
    return AuthenticationDao.recoverUsername(env, email);
  }
}
